export default function initAuthValidation() {
    const forms = document.querySelectorAll('.auth-form');
    if (!forms.length) return;

    forms.forEach(form => {
        const inputs = form.querySelectorAll('input, select, textarea');

        inputs.forEach(input => {
            input.addEventListener('invalid', function () {
                if (this.validity.valueMissing) {
                    this.setCustomValidity(this.getAttribute('data-msg-required') || 'Dieses Feld ist erforderlich');
                } else if (this.validity.typeMismatch && this.type === 'email') {
                    this.setCustomValidity(this.getAttribute('data-msg-email') || 'Bitte geben Sie eine gültige E-Mail-Adresse ein');
                }
            });

            input.addEventListener('input', function () {
                if (this.validity.customError) {
                    this.setCustomValidity('');
                }
            });
        });
    });
}


